export default "__VITE_ASSET__CIWm9UxD__"